module.exports = __webpack_public_path__ + "57d372e3b1eb9ef021c7cf909c629156.svg";


//////////////////
// WEBPACK FOOTER
// ./client/components/TopMenu/icons/telegram-svg.svg
// module id = 1562
// module chunks = 0